<template>
<div>
    <b-modal id="tnc-modal" cancel-variant="outline-secondary" ok-title="Submit" ref="my-modal" no-close-on-backdrop cancel-title="Close" size="lg" centered title="Terms and Conditions">
        <b-form>
            <b-form-group>
                <label for="subject">Terms Subject 條款名稱:</label>
                <b-form-input id="subject" type="subject" v-model="form.subject" placeholder="Subject 條款名稱" />
            </b-form-group>
            <b-form-group>
                <label for="content">Terms Content 條款內容</label>
                <b-form-textarea v-model="form.tnc" placeholder="Content 條款內容" rows="10" max-rows="20" />
            </b-form-group>
        </b-form>
        <template #modal-footer="{ ok , closeModal  }">
            <b-button size="sm" variant="primary" @click="submit()">
                Submit
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="close()">
                Close
            </b-button>
        </template>
    </b-modal>
    <b-row>
        <b-col md="12" lg="12">
            <b-row>
                <b-col md="10" lg="10" class="mb-1">
            
            <div class="d-flex">
                <feather-icon icon="UserIcon" size="19" />
                <h4 class="mb-50 ml-50">
                    {{ $t('Terms And Conditions') }}
                </h4>
                </div>
                </b-col>
                <b-col md="2" lg="2">
                <b-button size="sm" block  variant="primary" @click="open()">
                    Add
                </b-button>
                </b-col>
            </b-row>
            <!-- Form: Personal Info Form -->
            <b-table ref="selectableTable" selectable  :items="items" :fields="fields" responsive striped class="mb-0" @row-selected="onRowSelected">
            </b-table>
            <b-form class="mt-1">
                <b-row>

                    <b-col cols="12" md="12" lg="12">
                        <b-form-group label="Invoice Terms 收據條款" class="mb-4">
                            <b-form-textarea v-model="data.account.invoice_terms" placeholder="Invoice Terms 收據條款" rows="3" max-rows="20" />
                        </b-form-group>
                    </b-col>
                    <!-- <b-col cols="12" md="12" lg="12">
                        <b-form-group label="Package Terms 套票條款" class="mb-4">
                            <b-form-textarea v-model="data.account.pt_terms" placeholder="Package Terms 套票條款" rows="3" max-rows="20" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="12" lg="12">
                        <b-form-group label="Membership Terms 會籍條款">
                            <b-form-textarea v-model="data.account.membership_terms" placeholder="Membership Terms 會籍條款" rows="3" max-rows="20" />
                        </b-form-group>
                    </b-col> -->
                </b-row>

                <b-row class="mt-2 mb-2">
                    <b-col>
                        <b-button :disabled="processing" variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="save">
                            Save Changes
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-col>

    </b-row>
</div>
</template>

    
    
<script>
import {
    BFormTextarea,
    BCardText,
    BAlert,
    BLink,
    BCard,
    BCardHeader,
    BFormFile,
    BCardBody,
    BMedia,
    BFormCheckbox,
    BAvatar,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BTable,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BTab,
    BTabs,
    BListGroup,
    BListGroupItem,
    BBadge
} from 'bootstrap-vue'
import {
    ref
} from '@vue/composition-api'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import moment from 'moment'
import Ripple from 'vue-ripple-directive'

export default {
    directives: {
        Ripple,
    },
    components: {
        ToastificationContent,
        BFormTextarea,
        BFormCheckbox,
        BTable,
        BBadge,
        BCard,
        BCardText,
        vSelect,
        flatPickr,
        BFormFile,
        BCard,
        BCardHeader,
        BCardBody,
        BAvatar,
        BListGroup,
        BListGroupItem,
        BForm,
        BFormGroup,
        BMedia,
        BFormInput,
        BFormRadioGroup,
        BFormCheckboxGroup,
        BButton,
        BRow,
        BCol,
        BTab,
        BTabs,
        BCard,
        BAlert,
        BLink,
    },
    data() {
        return {
            items: [],
            form: {
                uuid: null,
                subject: null,
                tnc: null
            },
            fields: [{
                    key: 'subject',
                    label: 'Subject',
                    sortable: false
                },
                {
                    key: 'created_at',
                    label: 'Create At'
                }
            ],
            processing: false
        }
    },

    computed: {

    },
    props: {
        data: {
            required: true,
        },
    },
    created() {
        this.get_data()
    },

    methods: {
        submit() {
this.$http.post(process.env.VUE_APP_API_BASE+`/tnc/`, {tnc: this.form})
        .then(res => {
          if (res.data.result === true) {
           
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
            this.close()

          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
        },
  close() {
      this.form =  {
                uuid: null,
                subject: null,
                tnc: null
            }
      this.$refs['my-modal'].hide()
      this.get_data()
    },
    open() {
         this.form =  {
                uuid: null,
                subject: null,
                tnc: null
            }
         this.$refs['my-modal'].show()
    },
        get_data() {
            this.$http.get(process.env.VUE_APP_API_BASE + `/tnc/`)
                .then(res => {
                    this.items = res.data.records
                })
        },

        onRowSelected(items) {
            this.form.uuid = items[0]['uuid']
            this.form.subject = items[0]['subject']
            this.form.tnc = items[0]['tnc']
            this.$refs['my-modal'].show()
        },
        save() {
            this.processing = true
            this.data.account.base64 = this.base64
            this.$http.post(process.env.VUE_APP_API_BASE + `/account/?page=tnc`, this.data.account)
                .then(res => {
                    if (res.data.result === true) {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Success',
                                icon: 'CheckIcon',
                                variant: 'success',
                                text: res.data.message,
                            },
                        })
                        this.processing = false
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message,
                            },
                        })
                        this.processing = false
                    }
                })
        },

    },
}
</script>
    
    
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
